import axios from "axios";
import { CatalogItem, Product, ProductDetail } from "../utils/interfaces";
import { REACT_APP_BASE_MS_GW_API } from "../constants";

const BASE_URL = REACT_APP_BASE_MS_GW_API;
// const BASE_URL = "http://localhost/ext/v1/catalogo";

export const getMacrocategories = async (): Promise<CatalogItem[]> => {
  try {
    const response = await axios.get(
      `${BASE_URL}nodi/`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Errore nella richiesta API per ottenere le macrocategorie:",
      error
    );
    throw error;
  }
};

export const getChildrenById = async (macrocategoryId: string): Promise<CatalogItem[]> => {
  try {
    const response = await axios.get(
      `${BASE_URL}nodi/${macrocategoryId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Errore nella richiesta API per ottenere la macrocategoria:",
      error
    );
    throw error;
  }
};

export const getAllProducts = async (): Promise<Product[]> => {
  try {
    const response = await axios.get(
      `${BASE_URL}mappa/`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product catalog", error);
    throw error;
  }
};

export const getProdottoById = async (idProdotto: string): Promise<ProductDetail> => {
  try {
    const response = await axios.get(
      `${BASE_URL}prodotto/${idProdotto}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product by ID:", error);
    throw error;
  }
};
